export default "__VITE_ASSET__DPBLzrYJ__"